import { Fade, ButtonBase, Grid, Paper } from '@material-ui/core';
import React from 'react';
import { Link } from 'react-router-dom';
import { URL_SELECT } from 'settings';

import type { User } from 'v2/interfaces/user';

import { useStyles } from './styles';
import { WithQualificationValidation } from './withQualificationValidation';

export type QuickStartProps = {
  user: User;
};

function QuickStart({ user }: QuickStartProps) {
  const classes = useStyles();

  return (
    <Fade in timeout={500}>
      <Paper className={classes.paper}>
        <div className={classes.title}>
          <h1>Olá, {user.name}</h1>
          <span>
            Agora que você é Parceiro Eduzz, está pronto para iniciar seu trabalho, seja como afiliado ou produtor de conteúdos digitais.Escolha
            abaixo por onde deseja começar.
          </span>
        </div>
        <div className='m24' />
        <Grid container spacing={2}>
          <Grid item md={6} xs={12}>
            <Link to={'/producer/product/newproduct'}>
              <ButtonBase classes={{ root: classes.button }}>
                <strong>Cadastre seu produto</strong>
                <span>Venda cursos online,e-books, softwares, ingressos para eventos, musicas ou qualquer outro tipo de produto digital.</span>
              </ButtonBase>
            </Link>
          </Grid>
          <Grid item md={6} xs={12}>
            <a href={URL_SELECT}>
              <ButtonBase classes={{ root: classes.button }}>
                <strong>Afilie-se a um produto</strong>
                <span>Entre em nossa vitrine, escolha um produto para se afiliar e promova-o em troca de comissões por cada venda</span>
              </ButtonBase>
            </a>
          </Grid>
          <Grid item md={6} xs={12}>
            <a target='_blank' rel='noopener noreferrer' href={'https://academia360.eduzz.com/cursos?utm_source=orbita&utm_medium=quickstart'}>
              <ButtonBase classes={{ root: classes.button }}>
                <strong>Primeiros passos no Marketing Digital</strong>
                <span>Aprenda a melhor forma de se tornar um empreendedor digital e fazer vendas com os cursos gratuitos da Academia 360.</span>
              </ButtonBase>
            </a>
          </Grid>
          <Grid item md={6} xs={12}>
            <Link to={'/producer/news/list'}>
              <ButtonBase classes={{ root: classes.button }}>
                <strong>Novidades</strong>
                <span>Fique por dentro das principais novidades que estão acontecendo no Orbita e nas outras plataforma da Eduzz!</span>
              </ButtonBase>
            </Link>
          </Grid>
        </Grid>
      </Paper>
    </Fade>
  );
}

export default WithQualificationValidation(QuickStart);
